// Importing the date service extends dayjs with utc/timezone, which mapSchedulesToEvents needs.
import 'common/services/dateService'

import { mapSchedulesToEvents } from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/mapSchedulesToEvents'
import {
  type JointScheduleEvent,
  mergeJointScheduleRows,
} from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/mergeJointScheduleRows'
import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

// Joint rows of one visit share the day, so they merge into one card as in the week calendar.
const byDate = (event: IPatientSchedule): string => event.date

// The event a calendar click opens: real instants as Dates, joint rows merged into the primary.
export const toDialogEvent = (
  items: IPatientSchedule[],
  id: number,
  timeZone: string,
): JointScheduleEvent | null => {
  const sameDay = items.filter((item) => item.id === id).map((item) => item.date)
  const candidates = items.filter((item) => sameDay.includes(item.date))
  const events = mergeJointScheduleRows(mapSchedulesToEvents(candidates, timeZone, byDate))
  return events.find((event) => event.id === id || event.joint_row_ids?.includes(id)) ?? null
}
